import type { Icon, IconWeight } from '@phosphor-icons/react'
import { useContext, useEffect, useRef } from 'react'
import { PrimaryActionSetContext } from './PrimaryActionContext'

// Register this page's primary action as the bottom nav's center button, or `null` to hide it. The slot
// is single-occupancy and cleared on unmount. `onClick` is read through a ref so an inline handler
// doesn't re-register the slot on every render.
export function usePrimaryAction(action: { icon: Icon; label: string; onClick: () => void; weight?: IconWeight } | null): void {
  const setAction = useContext(PrimaryActionSetContext)
  if (!setAction) throw new Error('usePrimaryAction must be used within PrimaryActionProvider')

  const onClickRef = useRef(action?.onClick)
  onClickRef.current = action?.onClick

  const icon = action?.icon
  const label = action?.label
  const weight = action?.weight
  useEffect(() => {
    if (!icon || !label) {
      setAction(null)
      return
    }
    setAction({ icon, label, weight, onClick: () => onClickRef.current?.() })
    return () => setAction(null)
  }, [setAction, icon, label, weight])
}
